var maskOptions = {
  mask: '+{7}(000)000-00-00'
};

document.querySelectorAll('.correct.phone').forEach(el => {
    let mask = new IMask(el, maskOptions);
});
